module.exports = __webpack_public_path__ + "img/sc-3&4p-2022.1282b91c.png";